(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-tennis/helpers/tennis-helper.js') >= 0) return;  svs.modules.push('/components/themes/sport-tennis/helpers/tennis-helper.js'); 
(function() {
  'use strict';

  var isServerSide = typeof exports === 'object';
  if (!isServerSide) {
    registerHelpers(Handlebars);
  }

  function registerHelpers(hbs) {
    hbs.registerHelper('statsWithLineBreak', function(name) {
      return new Handlebars.SafeString(name.replace(') ', ')<br>'));
    });

    hbs.registerHelper('ifShowOdds', function(match, options) {
      var showOdds =
        match.isShowOdds && !svs.themes.sport_tennis.hasStarted(match.status);

      if (showOdds) {
        return options.fn(this);
      }
      return options.inverse(this);
    });

    hbs.registerHelper('formatPrizeMoney', function(prizeMoney) {
      if (prizeMoney) {
        var prizeMoneyNoCurrency = parseInt(prizeMoney, 10);
        var currency = prizeMoney.substring(
          prizeMoneyNoCurrency.toString().length
        );
        var prizeMoneyFormatted = svs.utils.format.Currency(
          prizeMoneyNoCurrency
        );
        return prizeMoneyFormatted + ' ' + currency;
      }
      return '';
    });

    hbs.registerHelper('tournamentName', function(name) {
      if (name) {
        var nameSplitted = name.split(',');
        return nameSplitted[0];
      }
      return '';
    });
  }
})();

 })(window);